<div class="background-overlay" [class.light]="isLightPage"></div>
<div class="wrapper">
  <div class="header" [class.opened]="navigationOpened">
    <div class="background-plain">
    </div>
    <div class="background">
      <img src="assets/header-background.svg"/>
    </div>
    <div class="heading">
      <div class="logo">
        <img src="assets/mpag-logo.svg" alt="Logo MPAG"/>
      </div>
      <div class="title">
        Mess-Profis Mieterportal
      </div>
      <div class="button navigation">
        <button mat-icon-button (click)="toggleNavigation()">
          <mat-icon *ngIf="!navigationOpened" svgIcon="mp_menu"></mat-icon>
          <mat-icon *ngIf="navigationOpened" svgIcon="mp_close"></mat-icon>
        </button>
      </div>
      <div class="button back" *ngIf="showBackButton">
        <button mat-icon-button (click)="goBack()">
          <mat-icon svgIcon="mp_back"></mat-icon>
        </button>
      </div>
      <div class="menu">
        <mp-menu [closeMenuCallback]="getCloseMenuCallback()"></mp-menu>
      </div>
    </div>
  </div>
  <div class="page" [class.light]="isLightPage">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="footer">
    <div class="menu">
      <mp-menu [closeMenuCallback]="getCloseMenuCallback()"></mp-menu>
    </div>
  </div>
</div>
